import { render, staticRenderFns } from "./DetailListItem.vue?vue&type=template&id=5f552929"
import script from "./DetailListItem.vue?vue&type=script&lang=js"
export * from "./DetailListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports